import { render, staticRenderFns } from "./ServiceScheduleEditShiftModal.vue?vue&type=template&id=3963202e&scoped=true&"
import script from "./ServiceScheduleEditShiftModal.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduleEditShiftModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceScheduleEditShiftModal.vue?vue&type=style&index=0&id=3963202e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963202e",
  null
  
)

export default component.exports